import React from "react";
import { connect } from "react-redux";
import * as actions from "../../../store/actions";

import {
    CopyService,
    LocalStorageService,
} from "/services";

import { EstateTeaser } from "/components/estate-teaser/EstateTeaser";
import { EstateNavigationService } from "/services";
import Select from "react-select";

const getTeaserGridClass = () => {
    if (window.searchMaximumItemsInARow === 2) {
        return "mini-teaser-grid";
    }

    if (window.searchMaximumItemsInARow === 3) {
        return "small-teaser-grid";
    }

    return "teaser-grid";
};

const sortByPriceAscending = items => items.sort((a, b) => {
    if (b.displayPrice === false) {
        return -1;
    }

    return parseInt(a.priceForSorting) - parseInt(b.priceForSorting);
});

const sortByPriceDescending = items => items.sort((a, b) => {
    if (b.displayPrice === false) {
        return -1;
    }

    return parseInt(b.priceForSorting) - parseInt(a.priceForSorting);
});

const sortByDateAscending = items => items.sort((a, b) => {
    return Date.parse(a.putOnlineDateTime.date.substring(0, 10)) - Date.parse(b.putOnlineDateTime.date.substring(0, 10));
});

const sortByDateDescending = items => items.sort((a, b) => {
    return Date.parse(b.putOnlineDateTime.date.substring(0, 10)) - Date.parse(a.putOnlineDateTime.date.substring(0, 10));
});

const sortings = {
    PRICE_ASCENDING: {
        key: "PRICE_ASCENDING",
        label: CopyService.get('estateSearch.cheapestFirst'),
        sort: sortByPriceAscending,
    },
    PRICE_DESCENDING: {
        key: "PRICE_DESCENDING",
        label: CopyService.get('estateSearch.mostExpensiveFirst'),
        sort: sortByPriceDescending,
    },
    DATE_ASCENDING: {
        key: "DATE_ASCENDING",
        label: CopyService.get('estateSearch.oldestFirst'),
        sort: sortByDateAscending,
    },
    DATE_DESCENDING: {
        key: "DATE_DESCENDING",
        label: CopyService.get('estateSearch.newestFirst'),
        sort: sortByDateDescending,
    },
};

const InternalEstateSearchResultsList = props => {
    const { showMap, setShowMap } = props;

    const sort = items => sortings[props.sorting].sort(items);

    const sortedEstates = sort(props.hits);

    const internalSetSorting = sorting => {
        props.setSorting(sorting);
        LocalStorageService.set("estate-search-sorting", sorting);
    };

    EstateNavigationService.setSearchResults(sortedEstates.map(estate => estate.url));

    const count = sortedEstates.length;

    const results = count === 1 ? CopyService.get('estateSearch.result') : CopyService.get('estateSearch.results');

    return (
        <div className="estate-search-results">
            {sortedEstates.length === 0 && (
                <div className="estate-search-results__no-results">
                    <h2 className="headline-3">
                        {CopyService.get('estateSearch.noResults')}
                    </h2>
                    <div className="estate-search-no-results-cta">
                        <h3 className="headline-4">
                            {CopyService.get('estateSearch.noResultsCTA')}
                        </h3>
                        <p>
                            {CopyService.get('estateSearch.noResultsCTADescription')}
                        </p>
                        <a className="button is-orange font-supplementary--bold" href={window.estateOverview.estateSearchForm}>
                            {CopyService.get('estateSearch.noResultsCTAButton')}
                        </a>
                    </div>
                </div>
            )}
            {sortedEstates.length > 0 && (
                <React.Fragment>
                    <div className="estate-search-results__actions">
                        {window.estateOverview.allowMapView && (
                            <button onClick={() => { setShowMap(!showMap); }}>
                                {showMap ? CopyService.get('estateSearch.hideMap') : CopyService.get('estateSearch.showMap')}
                            </button>
                        )}
                        <Select
                            className="react-select"
                            classNamePrefix="react-select"
                            options={Object.values(sortings)}
                            getOptionLabel={option => option.label}
                            getOptionValue={option => option.key}
                            value={sortings[props.sorting]}
                            isSearchable={false}
                            onChange={(option) => { internalSetSorting(option.key); }}
                            placeholder={CopyService.get('estateSearch.sortBy')}
                        />
                    </div>
                    <div className="estate-search-results__header font-supplementary--bold">
                        <div className="ais-Stats">
                            <span className="ais-Stats-text">
                                { count } { results } {CopyService.get('estateSearch.found')}
                            </span>
                        </div>
                    </div>
                    <div className="estate-search-results__results">
                        <div className={getTeaserGridClass()}>
                            {sortedEstates.map((estate, index) => {
                                let miniCTA;
                                if (index > 0 && index % 4 === 0) {
                                    miniCTA = window.miniCallToActions[(index / 4) - 1];
                                }

                                return (
                                    <React.Fragment key={`${showMap ? 'map' : 'nomap'}-${estate.id}`}>
                                        {miniCTA && (
                                            <div className="mini-call-to-action">
                                                <div className="mini-call-to-action__title headline-3 font-supplementary--bold">
                                                    {miniCTA.title}
                                                </div>
                                                <div className="mini-call-to-action__description">
                                                    {miniCTA.description}
                                                </div>
                                                <div className="mini-call-to-action__actions">
                                                    <a className="button is-orange font-supplementary--bold" href={miniCTA.button.url}>
                                                        {miniCTA.button.text}
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                        <EstateTeaser estate={estate} />
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    </div>
                </React.Fragment>
            )}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        allEstates: state.categories.allEstates,
        sorting: state.filterValues.sorting,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setSorting: sorting => dispatch(actions.setSorting(sorting)),
    };
};

const EstateSearchResultsList = connect(
    mapStateToProps,
    mapDispatchToProps,
)(InternalEstateSearchResultsList);

export { EstateSearchResultsList };
